import { type PayAppLoadInfoInternal } from '../types/PayAppLoadInfo';
import { type StringBoolean } from '../types/StringBoolean';

export const globals = {
  get loadInfo(): PayAppLoadInfoInternal {
    return window.__LOAD_INFO__;
  },

  get locale(): string {
    return window.__LOCALE__;
  },

  get l10n(): Record<string, string> {
    return window.__L10N__;
  },

  get experiments(): { [experimentName: string]: StringBoolean } {
    return window.__EXPERIMENTS__;
  },
};
